import RestResource from '../rest.service';
import Service from '../api.service';

export default class OrderItemsService extends RestResource {
  map(payload) {
    return {
      article_id: payload.article ? payload.article.id : null,
      quantity: payload.quantity,
      unit_price: payload.price,
      distributor_cost: payload.distributorCost,
    };
  }

  setOrder(orderId) {
    this.parents = [];
    this.parents.push(orderId);
    return this;
  }

  get(params = {}) {
    return Service.get('orders-items', { params: params }).catch(this.handleErrors);
  }

  constructor() {
    super('orders/$0/items');
  }
}
